import { createApp } from 'vue';
import App from "./App.vue";

import router from "./router";
import store from "./store";

import ElementPlus from 'element-plus';
import "element-plus/lib/theme-chalk/index.css";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'



//阿里图标
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import 'xe-utils'
import 'vxe-table/lib/style.css'

import components from './components'
import * as signalr from './utils/signalR'

import "./styles/index.scss";
import "@/styles/color/index.scss";

const app = createApp(App)
app.config.globalProperties.$signalr = signalr
app.use(store)
    .use(router)
    .use(ElementPlus)
    .use(components)
    .mount("#app")
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}